import { Nullable } from '@clearverify/types';

import { PeoInfoFragment, PeoPayrollProviderInfoFragment } from 'src/api';

export enum InviteFormFields {
  employers = 'employers',
  peoPayrollProvider = 'peoPayrollProvider',
  peo = 'peo',
}

export enum InviteFormEmployerFields {
  email = 'email',
  shouldCreateBillingRules = 'shouldCreateBillingRules',
}

export type InviteFormUserValues = {
  [InviteFormEmployerFields.email]: string;
  [InviteFormEmployerFields.shouldCreateBillingRules]: boolean;
};

export type InviteFormValues = {
  [InviteFormFields.employers]: InviteFormUserValues[];
  [InviteFormFields.peoPayrollProvider]: Nullable<PeoPayrollProviderInfoFragment>;
  [InviteFormFields.peo]: Nullable<PeoInfoFragment>;
};
